export const calculateHomeAdjustment = ({ homeAdjVal, homeAdj, isHomeAdjPercentage, isHomeAdjPositive }) => {
  const adjustmentFactor = isHomeAdjPositive ? 1 : -1;

  const result = isHomeAdjPercentage
    ? homeAdjVal * (1 + adjustmentFactor * (homeAdj / 100))
    : homeAdjVal + adjustmentFactor * homeAdj;

  return `$${Number(Math.floor(result)).toLocaleString()}`;
};
